export default "__VITE_ASSET__wYAF7k$g__"